var spoiler_default = {
  "fontElementMap": "wuXCK",
  "hideText": "RcP55",
  "onHoverText": "yBVDP",
  "hideBlock": "jMQP2",
  "smallBlur": "_6nfrb",
  "mediumBlur": "FOuwk",
  "largeBlur": "KhXfU",
  "hideBlock_gallery": "_76c1n",
  "overlay": "gOvwR",
  "overlay_gallery": "_5Y4lo",
  "revealSpoilerBtn": "TCLT-",
  "isMobile": "_9Fz-N",
  "onHoverBtn": "ldt42",
  "spoilerWrapper": "t50TQ",
  "spoilerDescription": "dBEA7",
  "spoilerContainer": "S-AW0",
  "spoilerContainer_Gallery": "f0Sqd"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
